import { FC, useEffect, useState } from "react";
import { Modal, ModalProps } from "antd";
import "./index.less";
import { tenantListTree, switchTenant } from "@/api/tenant";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TStoreData } from "@/interface";

const TenantModal: FC<ModalProps> = ({ open, onOk, ...resetProps }) => {
    const [firstTenantListTree, setFirstTenantListTree] = useState<any[]>([]);

    const firstTenant = useSelector((data: TStoreData) => {
        return data.firstTenant;
    });
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        if (open) {
            tenantListTree()
                .then((res) => {
                    setFirstTenantListTree((res.data || []) as any[]);
                })
                .catch((res) => {
                    console.log(res);
                });
        }
    }, [open]);

    const chooseTenant = (tenantItem: any) => {
        const { tenantCode } = tenantItem;
        switchTenant({ tenantCode })
            .then((res: any) => {
                dispatch({
                    type: "setFirstTenant",
                    value: tenantItem,
                });
                onOk?.(null as any);
                history.replace("/home");
            })
            .catch((err: any) => {
                console.error("err: ", err);
            });
    };

    return (
        <Modal title={"我的组织:"} open={open} {...resetProps} footer={null}>
            <div className="org-list-content">
                <div className="org-list-title">
                    <div className="org-change">切换一级组织:</div>
                </div>
                {firstTenantListTree?.map((orgItem, index) => {
                    return (
                        <div className="org-item" key={orgItem.tenantCode}>
                            <div className="zone-row-container">
                                <img
                                    src="https://img13.360buyimg.com/imagetools/jfs/t1/110692/28/20277/1552/61df9ebeE94dc9641/29ef1a4099bfa6c0.png"
                                    className="zone-row-icon"
                                    alt=""
                                />
                                <div
                                    onClick={() => chooseTenant(orgItem)}
                                    className={
                                        firstTenant.tenantCode ===
                                        orgItem.tenantCode
                                            ? "zone-row-content-select zone-row-content"
                                            : "zone-row-content"
                                    }
                                >
                                    <span>{orgItem.orgName}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
};

export default TenantModal;
